import * as React from 'react';
import debounce from 'lodash.debounce';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TextField from "@mui/material/TextField";
// Redux
import { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
// icons
import SearchIcon from '@mui/icons-material/Search';
import { Grid, InputAdornment } from '@mui/material';
// components 
import SearchListGrid from '../searchListGrid/SearchListGrid';
import {
    getTargetListSelector,
    getTargetSelector
} from "../../../store/dataTarget/selectors";
import {
    deleteTargetReq,
    fetchTargetListReq,
    fetchTargetDetailsReq,
} from "../../../store/dataTarget/actions";
import { IDataTarget, IDataTargetDetails, ITargetListParams } from '../../../store/dataTarget/types';
import { HeadCell, Order } from '../tableGrid/types';
import EnhancedTable from '../tableGrid/tableGrid';
import EnhancedTableHead from '../tableGrid/tableHead';
import Row from '../tableGrid/tableRow';
import { useNavigate } from 'react-router-dom';
import { toggleDataTarget } from "../../../store/dataProvisioningWorkflow/actions";
import { getDataProvisioningWorkflowStateSelector } from '../../../store/dataProvisioningWorkflow/selectors'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { getProfileDataSelector } from '../../../store/auth/selectors';
import { SEARCH_DEBOUNCE_TIME_MILLIS } from "../../../constants/common";


// settings data

const headCells: HeadCell[] = [
    {
        id: 'selected',
        numeric: false,
        disablePadding: false,
        label: '',
        width: "50px",
    },
    {
        id: 'description',
        numeric: false,
        disablePadding: false,
        label: 'Description',
        width: "350px",
    },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Name',
        width: "250px",

    },
    {
        id: 'dbType',
        numeric: false,
        disablePadding: false,
        label: 'DbType',
        width: "150px",
    },
    {
        id: 'layerType',
        numeric: false,
        disablePadding: false,
        label: 'Type',
    },
    {
        id: 'schema',
        numeric: false,
        disablePadding: false,
        label: 'Schema',
    },
];

// end

const descendingComparator = (a: IDataTarget, b: IDataTarget, orderBy: keyof IDataTarget) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order: Order, orderBy: keyof IDataTarget): (
    a: IDataTarget,
    b: IDataTarget,
) => number => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
};

export type TargetExplorerProps = {
    personal?: boolean;
    isAdmin: boolean;
}

const TargetSelector = (props: TargetExplorerProps) => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dataRows, setDataRows] = useState<IDataTarget[]>([]);
    const [totalRows, setTotalRows] = useState(0);
    const [order, setOrder] = useState<Order>("asc");
    const [orderBy, setOrderBy] = useState<keyof IDataTarget>("description");
    const [rowDetails, setRowDetails] = useState<IDataTargetDetails[]>([]);
    const [selected, setSelected] = useState<readonly string[]>([]);
    const [open, setOpen] = useState(false);
    const [rowID, setRowID] = useState(0);
    const [rowName, setRowName] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [mail, setMail] = useState("")
    const userProfile = useSelector(getProfileDataSelector);
    // const selectable: string = "single";
    const allSelectable: boolean = false;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // target list   
    const targetList = useSelector(getTargetListSelector);

    // workflow state
    const workflowState = useSelector(getDataProvisioningWorkflowStateSelector)

    const params: ITargetListParams = {
        skip: page * rowsPerPage,
        top: rowsPerPage,
        count: true,
        search: searchTerm,
        orderby: `${orderBy} ${order}`
    };

    useEffect(() => {
        if (userProfile) {
            setMail(userProfile.mail)
        }
    }, [userProfile]);

    useEffect(() => {

        dispatch(fetchTargetListReq(params));

    }, [page, rowsPerPage, searchTerm]);

    useEffect(() => {
        let data: IDataTarget[] = targetList.targets;

        // const getdbType = (item: any) => {
        //     switch (item) {
        //         case 'LOAD_REDSHIFT':
        //             return "Redshift";
        //         case 'LOAD_S3':
        //             return "S3";
        //         case 'LOAD_ADLS':
        //             return "ADLS";
        //         case 'LOAD_MSSQL':
        //             return "MSSQL";
        //         case 'LOAD_ORACLE':
        //             return "ORACLE";
        //         case 'LOAD_POSTGRES':
        //             return "Postgres";
        //         case 'LOAD_SQLDW':
        //             return "SQLDW";
        //         default:
        //             return "NA";
        //     }
        // }

        // if (data && data.length > 0) {
        //     const newData = data.map((item: any, index: number) => {
        //         return { ...item, dbType: getdbType(item.layerType), id: index };
        //     })
        //     setDataRows(newData);
        // }
        // else {
        //     setDataRows(data);
        // }

        setDataRows(data);
        setTotalRows(targetList.count);
    }, [targetList]);

    // table related events 

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleRequestSort = (
        event: React.MouseEvent<unknown>,
        property: string,
    ) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property as keyof IDataTarget);
    };

    const handleClick = (event: React.MouseEvent<unknown>, target: IDataTarget) => {

        dispatch(toggleDataTarget(target));

    };


    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPage(0);
        setSearchTerm(e.target.value)

    }

    const handleSearchDebounce = useMemo(() => {
        return debounce(handleSearch, SEARCH_DEBOUNCE_TIME_MILLIS);
    }, []);

    const targetDetail = useSelector(getTargetSelector);
    useEffect(() => {

        let isDetailExists = false;
        if (targetDetail) {
            isDetailExists = rowDetails.filter((x) => x && x.targetId === targetDetail!.targetId).length > 0;
            if (!isDetailExists) {
                setRowDetails([...rowDetails, targetDetail!]);
            }
        }

    }, [targetDetail, rowDetails]);

    const searchEl = () => {
        return (
            <TextField
                id="target-search"
                label="Search Targets"
                type="search"
                fullWidth={true}
                onChange={handleSearchDebounce}
                InputProps={{
                    startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
                }}
            />
        );
    };

    const handleExpand = (row: IDataTarget) => {

        let isExist = rowDetails.find((x) => x && x.targetId === row.targetId);

        if (!isExist) {
            // dispatch get source details action
            dispatch(fetchTargetDetailsReq(row.targetId));
        }
    }

    const handleClose = () => {
        setOpen(false);
    }
    const handleTargetView = (row: IDataTarget, event: React.MouseEvent<HTMLButtonElement>) => {
        const url = `/ViewDataTarget/${row.targetId}`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    }

    const handleTargetEdit = (row: IDataTarget, event: React.MouseEvent<HTMLButtonElement>) => {
        const url = `/EditDataTarget/${row.targetId}`;
        if (event.ctrlKey) {
            window.open(url, '_blank')
        }
        else {
            navigate(url);
        }
    }

    const confirmTargetDelete = (row: IDataTarget) => {
        setOpen(true);
        setRowID(row.targetId);
        setRowName(row.name);

    }

    const handleTargetDelete = () => {
        setOpen(false);
        dispatch(deleteTargetReq(rowID));

    }

    const tableHeader = () => {
        return (
            <EnhancedTableHead
                headCells={headCells}
                numSelected={selected.length}
                selectable={allSelectable}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={totalRows}
            />
        );
    }

    const isSelected = (name: string) => selected.indexOf(name) !== -1;

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - totalRows) : 0;

    const filterUserAccessList = (ids: string) => {
        let dataStewards: any = [];
        if (ids !== null) {
            var splitIDs = ids.split(";").filter((x) => x !== "");

            splitIDs.forEach(function (value) {
                let user = { userName: value };
                dataStewards.push(user);
            });
        }
        let x = dataStewards.filter((x: any) => x.userName === mail);
        if (x.length > 0) return true
    };

    const filterOwner = (owner: string) => {

        if (owner.toLowerCase() === mail.toLowerCase()) {
            return true
        }
        else return false
    };


    const tableRows = () => {

        return (
            <>
                {dataRows?.length > 0 && dataRows.slice().sort(getComparator(order, orderBy))
                    //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row: IDataTarget, index: number) => {
                        const isItemSelected = workflowState?.selectedDataTarget?.name === row.name
                        // a target can be selected only if
                        // 1- User Access List is empty
                        // 2- the loggedin user's email is in user access list
                        // 3- the loggedin user is the owner
                        const userAccessList = filterUserAccessList(row.userAccessList)
                        const checkOwner = (row.owner != null) ? filterOwner(row.owner) : false;
                        return (

                            <Row row={row}
                                key={row.name}
                                headCells={headCells}
                                selectable={row.userAccessList === "" || row.userAccessList === null || userAccessList || checkOwner || props.isAdmin ? "single" : "na"}
                                canEdit={props.isAdmin || checkOwner}
                                canView={true}
                                canDelete={props.isAdmin || checkOwner}
                                canExpand={true}
                                isItemSelected={isItemSelected}
                                handleClick={(event) => row.userAccessList === "" || row.userAccessList === null || userAccessList || checkOwner || props.isAdmin ? handleClick(event, row) : ''}
                                handleExpand={handleExpand}
                                handleView={handleTargetView}
                                handleEdit={handleTargetEdit}
                                handleDelete={confirmTargetDelete}
                            >
                                {rowDetails.length > 0 &&
                                    <Box className="expand-details" sx={{ margin: 1 }}>

                                        <Grid container spacing={3}>

                                            <Grid item xs={7}>
                                                <div><span className="title">Name : </span><span>{row.name ?? "None"}</span></div>
                                                <div><span className="title">Description : </span><span>{row.description ?? "None"}</span></div>
                                                <div><span className="title">DB Type : </span><span>{row.dbType ?? "None"}</span></div>
                                                <div><span className="title">Owner : </span><span>{row.owner ?? "None"}</span></div>


                                            </Grid>
                                            <Grid item xs={5}>
                                                <div><span className="title">Cost Centre : </span><span>{row.costCentre ?? "None"}</span></div>
                                                <div><span className="title">User Access List : </span><span>{row.userAccessList ?? "None"}</span></div>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                }
                            </Row>
                        );
                    })}
                {emptyRows > 0 && emptyRows < 10 && (
                    <TableRow
                        style={{
                            height: (53) * emptyRows,
                        }}
                    >
                        <TableCell colSpan={6}>There are no targets available.</TableCell>
                    </TableRow>
                )}
                {dataRows?.length < 1 && (
                    <TableRow
                        style={{
                            height: (53) * emptyRows,
                        }}
                    >
                        <TableCell colSpan={6}>There are no targets available.</TableCell>
                    </TableRow>
                )}
            </>
        );
    }


    const listGrid = () => {

        return (
            <EnhancedTable
                totalRows={totalRows}
                tableHeader={tableHeader()}
                tableRows={tableRows()}
                pagination={true}
                page={page}
                rowsPerPage={rowsPerPage}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
        );
    }

    return (
        <>
            <SearchListGrid searchEl={searchEl()} children={listGrid()} />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete {rowName}?
                </DialogContent>
                <DialogActions>
                    <Button id="3d0ae393-6c7a-4304-8e55-90ab567b551d" onClick={handleClose} color="primary">
                        No
                    </Button>
                    <Button id="a36fe65e-c304-4546-8247-658038431848" onClick={handleTargetDelete} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );

};

export default TargetSelector;